import { Link } from "react-router-dom";
import { useRegion } from "../../context/RegionContext";
import { SERVICES } from "../../data/site";
import { SOCIAL_LINKS } from "../../data/social";
import { Linkedin, Mail, Phone, ArrowUpRight, Youtube, Instagram, Facebook, Twitter, Music2, Newspaper, Podcast } from "lucide-react";

const ICONS = { Linkedin, Youtube, Instagram, Facebook, Twitter, Music2, Newspaper, Podcast };

export default function Footer() {
  const { config, region } = useRegion();
  return (
    <footer data-testid="site-footer" className="bg-brand-blue-deep text-white mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6 bg-white/95 p-3 inline-flex rounded-sm">
            <img src="/brand-logo.webp" alt="All Things Social Impact" className="h-10 w-auto" />
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            A specialist advisory practice helping leaders identify social risk early, improve project design and approvals, strengthen community outcomes and reduce delivery risk.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/80">
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand-yellow" /> {config.email}</div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-yellow" /> {config.phone}</div>
          </div>

          <div className="mt-8">
            <div className="eyebrow text-brand-yellow mb-4">Follow along</div>
            <div className="flex flex-wrap gap-2" data-testid="footer-social-icons">
              {SOCIAL_LINKS.map((s) => {
                const Icon = ICONS[s.icon] || Linkedin;
                return (
                  <a
                    key={s.key}
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`${s.label} - ${s.handle}`}
                    title={`${s.label} · ${s.handle}`}
                    data-testid={`social-${s.key}`}
                    className="w-10 h-10 flex items-center justify-center border border-white/20 hover:border-brand-yellow hover:text-brand-yellow text-white/80 transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div>
          <div className="eyebrow text-brand-yellow mb-4">Services</div>
          <ul className="space-y-2 text-sm text-white/75">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-brand-yellow transition-colors">{s.title}</Link>
              </li>
            ))}
            <li><Link to="/services" className="text-brand-yellow font-semibold inline-flex items-center gap-1">All services <ArrowUpRight className="w-3.5 h-3.5" /></Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-brand-yellow mb-4">Practice</div>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/about" className="hover:text-brand-yellow">About Andrea Kanaris</Link></li>
            <li><Link to="/industries" className="hover:text-brand-yellow">Industries</Link></li>
            <li><Link to="/case-studies" className="hover:text-brand-yellow">Case studies</Link></li>
            <li><Link to="/insights" className="hover:text-brand-yellow">Insights</Link></li>
            <li><Link to="/podcast" className="hover:text-brand-yellow">Voices of Change podcast</Link></li>
            <li><Link to="/practitioners" className="hover:text-brand-yellow">For practitioners</Link></li>
            <li><Link to="/contact" className="hover:text-brand-yellow">Contact Us</Link></li>
          </ul>
          <div className="mt-8 border-t border-white/10 pt-4 text-xs text-white/50 leading-relaxed">
            {config.entity}<br />{config.address}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} All Things Social Impact. All rights reserved.</div>
          <div className="uppercase tracking-[0.25em]">Region: {region === "AU" ? "Australia" : "United States"}</div>
        </div>
      </div>
    </footer>
  );
}
